let map;
let marker;
let infoWindow;
let datosMarcadores;
let marcadoresActivos = [];
let Mapa, Marcador, Punto, Autocompletado;

const CATEGORY_ICONS =[
  {URL_IMAGEN: "https://cdn.shopify.com/s/files/1/0662/2681/5204/files/travel-and-tourism.png",
     ID:1,
  },
  {URL_IMAGEN: "https://cdn.shopify.com/s/files/1/0662/2681/5204/files/food-restaurant.png",
    ID:2,
  },
  {URL_IMAGEN:"https://cdn.shopify.com/s/files/1/0662/2681/5204/files/publicidad.png",
    ID:3,
  },
  {URL_IMAGEN:"https://cdn.shopify.com/s/files/1/0662/2681/5204/files/dinero.png",  
   ID:6,
  },
  {URL_IMAGEN:"https://cdn.shopify.com/s/files/1/0662/2681/5204/files/campo_d605fb22-30e0-43e3-ab59-0571ef4138dc.png",
    ID:8,
  },
  {URL_IMAGEN:"https://cdn.shopify.com/s/files/1/0662/2681/5204/files/cooperar.png", ID:9,},

  {URL_IMAGEN:"https://cdn.shopify.com/s/files/1/0662/2681/5204/files/campo_d605fb22-30e0-43e3-ab59-0571ef4138dc.png",
    ID:7,
  },
];




  //coordenada donde se cargara el mapa
function puntoDeOrigen() {
  
  map = new Mapa(document.getElementById("map"), {
    center: { lat: 2.8976942, lng: -82.1101564 },
    zoom: 4,
    mapId: "4504f8b37365c3d0",
    mapTypeControl: false,
  });
}

function ponerMarcador() {
  const $contenedorInput = document.querySelector("#place-autocomplete-card");
  const controlAutocompletado = new Autocompletado();

  controlAutocompletado.setAttribute("id", "place-autocomplete-input");
  $contenedorInput.appendChild(controlAutocompletado);
  map.controls[google.maps.ControlPosition.TOP_LEFT].push($contenedorInput);

  marker = new Marcador({
    map,
  });

  infoWindow = new google.maps.InfoWindow({});
  agregarEventoPlace(controlAutocompletado);
}

function agregarEventoPlace(controlAutocompletado) {
  controlAutocompletado.addEventListener(
    "gmp-placeselect",
    async ({ place }) => {
      let $contenedor = document.createElement("div");
      let $spanTitulo = document.querySelector("#place-displayname");
      let $spanDirecion = document.querySelector("#place-address");

      let $templateModal = document.querySelector("#template-modal").content;

      await place.fetchFields({
        fields: ["displayName", "formattedAddress", "location"],
      });

      if (place.viewport) {
        map.fitBounds(place.viewport);
      } else {
        map.setCenter(place.location);
        map.setZoom(17);
      }

      if ($spanTitulo || $spanDirecion) {
        $spanTitulo.textContent = place.displayName;
        $spanDirecion.textContent = place.formattedAddress;
      } else {
        let $nodoModal = document.importNode($templateModal, true);
        $nodoModal.querySelector("#place-displayname").textContent =
          place.displayName;
        $nodoModal.querySelector("#place-address").textContent =
          place.formattedAddress;
        $contenedor.appendChild($nodoModal);
        updateInfoWindow($contenedor, place.location);
      }

      marker.position = place.location;
    }
  );
}

async function inicializarMapa() {

const { Map} = await google.maps.importLibrary("maps");
const { AdvancedMarkerElement, PinElement } =
  await google.maps.importLibrary("marker");
const {PlaceAutocompleteElement} = await google.maps.importLibrary("places");
  

  Mapa = await Map;
  Marcador = await AdvancedMarkerElement;
  Autocompletado = await PlaceAutocompleteElement;

  Punto = await PinElement;

  puntoDeOrigen();
  obtenerData();
 // ponerMarcador();
 
  

}

function updateInfoWindow(content, center) {
  infoWindow.setContent(content);
  infoWindow.setPosition(center);
  infoWindow.open({
    map,
    anchor: marker,
    shouldFocus: false,
  });
  let $prueba = document.querySelector(".prueba");
  $prueba.appendChild(content);
}

async function obtenerData() {
 
  try {
    const respuesta = await fetch("https://172.26.1.130/ComunidadFund/api/Emprendimientos/GetEmprendimientosMapa");
    datosMarcadores = await respuesta.json();
     
      //datosMarcadores = await emprendimientos;
       datosMarcadores.forEach((property) => {

      crearMarcadorPersonalizado(property);
    });
  } catch (err) {
    console.log("Ocurrio el siguiente error", err);
  }
}

function construirElemento(property) {

  const $contentenedorMarcador = document.createElement("div");
  $contentenedorMarcador.classList.add("property");
  const $templateMarcador =
    document.querySelector("#template-marcador").content;
  let $nodoMarcador = document.importNode($templateMarcador, true);
  let $title = $nodoMarcador.querySelector(".marcador-title");
  let categoria = CATEGORY_ICONS.find(categoria => categoria.ID == property.categoriaID );
  let iconEmprendimiento = property.imagenPerfil

  
  $title.setAttribute("title", property.nombreEmpresa);
  $title.setAttribute("data-perfil", property.imagenPerfil);
   $title.setAttribute("data-estado", false);
  $title.setAttribute("data-categoria", categoria.URL_IMAGEN);
  $title.style.setProperty("background-image",`url(${categoria.URL_IMAGEN})`);
  $title.style.setProperty("background-repeat", "no-repeat");
  $title.style.setProperty("background-size", "cover");
  $title.style.setProperty("height", "25px");
  $title.style.setProperty("width", "25px");
  $nodoMarcador.querySelector(".titulo_emprendimiento").textContent = property.nombreEmpresa;
  $nodoMarcador.querySelector(".descripcion_emprendimiento").textContent = property.descripcion;

  
   

  

  $nodoMarcador
    .querySelector(".link-emprendimiento")
    .setAttribute("href", `https://fundacionpanaca.co/pages/ver-emprendimiento?id=${property.emprendimientoID}`);

  $contentenedorMarcador.appendChild($nodoMarcador);

  return $contentenedorMarcador;
}

function toggleHighlight(markerView, property) {

  let icono = markerView.content.querySelector(".marcador-title");
  
  if (markerView.content.classList.contains("highlight")) {
    
       icono.style.setProperty("background-image", `url(${icono.getAttribute("data-categoria")})`);
       icono.style.setProperty("width",  `24px`);
     icono.style.setProperty("height",  `24px`);
       markerView.content.classList.remove("highlight");
       markerView.zIndex = null;
  } else {
    
     icono.style.setProperty("background-image",  `url(${icono.getAttribute("data-perfil")})`);
     icono.style.setProperty("width",  `100px`);
     icono.style.setProperty("height",  `100px`);
    markerView.content.classList.add("highlight");

    markerView.zIndex = 1;
  }
}

function crearMarcadorPersonalizado(property) {
    console.log("la latiud, longitud",parseFloat(property.latitudMapa), parseFloat(property.longitudMapa) )
  const MarcadorPersonalizado = new Marcador({
    map,
    content: construirElemento(property),
    position:{
        "lat":parseFloat(property.latitudMapa),
        "lng": parseFloat(property.longitudMapa),
      }, 
    title: property.description,
  });

  marcadoresActivos.push(MarcadorPersonalizado);

  MarcadorPersonalizado.addListener("click", (event) => {

   
    toggleHighlight(MarcadorPersonalizado, property);
  });
}

document.addEventListener('click', (event)=>{
   let padre = event.target.closest('.property');
  
    if(padre && !padre.classList.contains('highlight')){
      padre.click();
    }
  

  if(!event.target.closest('.highlight, .property, .link-emprendimiento, .link')){
     let activo = document.querySelector('.highlight');
    if(activo){
      activo.click();
    }
   
  } 


   if(event.target.matches('.link')){
          let ancla = event.target.querySelector('.link-emprendimiento');
          ancla.click()
        }
   
 
})
function limpiarMarcadores() {
  marcadoresActivos.forEach((marcador) => {
    marcador.map = null;
  });
  marcadoresActivos = [];
}

function capturarCLicks() {
  document.addEventListener("change", (event) => {
    switch (true) {
      case event.target.matches(".select-categoria"):
        limpiarMarcadores();
        filtroCategorias(event.target.value);
        break;
    }
  });
}

capturarCLicks();
function filtroCategorias(value) {
  debugger;
   let filtroMarcador =  datosMarcadores;
  if(value != -1){
       filtroMarcador = datosMarcadores.filter(
  
    (marcador) =>marcador.categoriaID == parseInt(value)
  );
  }
 filtroMarcador.forEach((property) => {
    crearMarcadorPersonalizado(property);
  });

}
 

function cargaCompletPagina() {
  setTimeout(() => {
    const $buscador = document.querySelector(".place-autocomplete-card");
  
    $buscador.style.setProperty("display", "block");
  }, 500);
}


async function cargarCategorias() {
  try {
    const response = await fetch("https://172.26.1.130/ComunidadFund/api/Categorias/Categorias");
    
    if (!response.ok) {
      throw new Error('Error en la solicitud: ' + response.statusText);
    }

    const categorias = await response.json();
    const selectCategoria = document.querySelector(".select-categoria");

  
    selectCategoria.innerHTML = '';
    const optionPrincipal = document.createElement("option");
      optionPrincipal.value = "-1";
     optionPrincipal.textContent = "Todas las categorias"; 
    selectCategoria.appendChild(optionPrincipal);
    categorias.forEach(categoria => {
      const option = document.createElement("option");
      option.value = categoria.categoriaID;
      option.textContent = categoria.categoriaName; 
      selectCategoria.appendChild(option);
    });

  } catch (error) {
    console.error('Error al cargar categorías:', error);
  }
}
 document.addEventListener('touchstart', (event)=>{

        if(event.target.matches('.link')){
          let ancla = event.target.querySelector('.link-emprendimiento');
          location.href = ancla.href;
        }


     
        if(event.target.matches('.link-emprendimiento')){  
          location.href = event.target;
        }

    if(!event.target.closest('.highlight, .property, .link-emprendimiento, .link')){
         let activo = document.querySelector('.highlight');
         let icono = activo.querySelector('.marcador-title');
         icono.style.setProperty("background-image", `url(${icono.getAttribute("data-categoria")})`);
         icono.style.setProperty("width",  `24px`);
         icono.style.setProperty("height",  `24px`);
         activo.classList.remove('highlight');
      
   
  } 

      });
document.addEventListener("DOMContentLoaded", cargaCompletPagina);
document.addEventListener("DOMContentLoaded", cargarCategorias);
window.initMap = inicializarMapa;